export const mississippi = {
  "28000": "Mississippi",
  "28001": "Adams County",
  "28003": "Alcorn County",
  "28005": "Amite County",
  "28007": "Attala County",
  "28009": "Benton County",
  "28011": "Bolivar County",
  "28013": "Calhoun County",
  "28015": "Carroll County",
  "28017": "Chickasaw County",
  "28019": "Choctaw County",
  "28021": "Claiborne County",
  "28023": "Clarke County",
  "28025": "Clay County",
  "28027": "Coahoma County",
  "28029": "Copiah County",
  "28031": "Covington County",
  "28033": "DeSoto County",
  "28035": "Forrest County",
  "28037": "Franklin County",
  "28039": "George County",
  "28041": "Greene County",
  "28043": "Grenada County",
  "28045": "Hancock County",
  "28047": "Harrison County",
  "28049": "Hinds County",
  "28051": "Holmes County",
  "28053": "Humphreys County",
  "28055": "Issaquena County",
  "28057": "Itawamba County",
  "28059": "Jackson County",
  "28061": "Jasper County",
  "28063": "Jefferson County",
  "28065": "Jefferson Davis County",
  "28067": "Jones County",
  "28069": "Kemper County",
  "28071": "Lafayette County",
  "28073": "Lamar County",
  "28075": "Lauderdale County",
  "28077": "Lawrence County",
  "28079": "Leake County",
  "28081": "Lee County",
  "28083": "Leflore County",
  "28085": "Lincoln County",
  "28087": "Lowndes County",
  "28089": "Madison County",
  "28091": "Marion County",
  "28093": "Marshall County",
  "28095": "Monroe County",
  "28097": "Montgomery County",
  "28099": "Neshoba County",
  "28101": "Newton County",
  "28103": "Noxubee County",
  "28105": "Oktibbeha County",
  "28107": "Panola County",
  "28109": "Pearl River County",
  "28111": "Perry County",
  "28113": "Pike County",
  "28115": "Pontotoc County",
  "28117": "Prentiss County",
  "28119": "Quitman County",
  "28121": "Rankin County",
  "28123": "Scott County",
  "28125": "Sharkey County",
  "28127": "Simpson County",
  "28129": "Smith County",
  "28131": "Stone County",
  "28133": "Sunflower County",
  "28135": "Tallahatchie County",
  "28137": "Tate County",
  "28139": "Tippah County",
  "28141": "Tishomingo County",
  "28143": "Tunica County",
  "28145": "Union County",
  "28147": "Walthall County",
  "28149": "Warren County",
  "28151": "Washington County",
  "28153": "Wayne County",
  "28155": "Webster County",
  "28157": "Wilkinson County",
  "28159": "Winston County",
  "28161": "Yalobusha County",
  "28163": "Yazoo County",
};
